"use client";var e="@sainsburys-tech/images",s="3.4.0";export{e as name,s as version};
